var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartners(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106.77 92.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.58,80.39l12.91-59.08c.99-4.53-1.88-9-6.4-9.99L47,1.7c-4.53-.99-9,1.88-9.99,6.4,0,0-.76,4.35-1.25,5.74-2.94,8.3-7.17,8.98-17.21,7.57S2.38,27.95,1.5,32.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.37,88.27c-1.95,1.84-4.74,2.71-7.55,2.1l-44.08-9.63c-4.53-.99-7.39-5.46-6.4-9.99l7.2-32.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.32,24.51h5.63c1.97,0,3.56,1.6,3.56,3.56v7.38c0,1.97-1.6,3.56-3.56,3.56h-5.63v-14.51h0Z",
    transform: "translate(9.09 -20.6) rotate(12.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.03,44.12h5.63c1.97,0,3.56,1.6,3.56,3.56v7.38c0,1.97-1.6,3.56-3.56,3.56h-5.63v-14.51h0Z",
    transform: "translate(13.17 -19.23) rotate(12.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.75,63.72h5.63c1.97,0,3.56,1.6,3.56,3.56v7.38c0,1.97-1.6,3.56-3.56,3.56h-5.63v-14.51h0Z",
    transform: "translate(17.26 -17.87) rotate(12.33)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.06,
    y1: 2.14,
    x2: 31.78,
    y2: 81.18
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners);
export default __webpack_public_path__ + "static/media/partners.555e71365da54195fe5ff2e2fa034b37.svg";
export { ForwardRef as ReactComponent };